export enum USER_ACTIONS_TYPES {
  USER_SET_DATA = 'USER_SET_DATA',
  USER_REMOVE_DATA = 'USER_REMOVE_DATA',
  USER_RESET_DATA = 'USER_RESET_DATA',
}

export const USER_LOCAL_KEY = '_usr' as const

export type UserAccountStatus =
  | 'OK'
  | 'UNREGISTERED'
  | 'INCOMPLETE_REGISTER'
  | 'PENDING_CONFIRMATION'
  | 'ALREADY_REGISTERED'
  | 'UNKNOWN'

export type User = {
  name?: string
  email?: string
  gender?: number
  sub: string
  phone_number: string
  total_scores?: number
  birthdate?: string
  password?: string
  picture?: string
  [k: string]: any
}

export type Intents = {
  code: number
  reason: string
  channels: string[]
  trusty: boolean
  signature: string
  metadata: null | Record<string, any>
  expiryAt: string
  createdAt: string
}

export type UserState = {
  scores?: number
  intents: Intents[]
  attributes: User
}

export type UserSetDataAction = {
  type: USER_ACTIONS_TYPES.USER_SET_DATA
  payload: Partial<UserState>
}

export type UserResetDataAction = {
  type: USER_ACTIONS_TYPES.USER_RESET_DATA
}

export type UserActions = UserSetDataAction | UserResetDataAction
